import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PalleteColor } from 'nanaykuna-ui-kit/loader';
import { ActionButtonStyle } from './action-button.types';

@Component({
  selector: 'unicon-action-button',
  templateUrl: './action-button.component.html',
  styleUrls: ['./action-button.component.scss'],
})
export class ActionButtonComponent {
  @Input() icon!: string;
  @Input() text!: string;
  @Input() buttonStyle: ActionButtonStyle = 'action';
  @Input() disabled: boolean = false;
  @Input() iconFill: PalleteColor = 'neutrals-900';

  @Output() clicked = new EventEmitter<void>();

  protected onClick(event: Event): void {
    event.stopImmediatePropagation();
    this.clicked.emit();
  }
}
